//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import matchHeightAfterImgLoad from 'lib/match-height-after-img-load';

let elements = '.events > *';

export default {
  props: {
    title: String
  },
  data() {
    return {className: ''};
  },
  mounted() {
    matchHeightAfterImgLoad(elements);
  },
  updated() {
    matchHeightAfterImgLoad(elements);
  }
}



// WEBPACK FOOTER //
// ./app/components/organisms/event-grid/event-grid.vue